import { useIntl } from 'react-intl';

import { FilterTypeLegacy, SimpleEventTypeLegacy } from '@verantos-dev/types-cohorts';

import { CohortBuilderEditModalActionButtonProps } from '../../../../../components/CohortBuilderEditModal/CohortBuilderEditModalActions/CohortBuilderEditModalActionButton';
import { getAvailableEventTypes } from '../../../../../utils/getAvailableEventTypes';

export const useSimpleEventCohortBuilderEditModalActions = ({
  type,
  uniquenessFilters,
  onAddConceptFilterClick,
  onAddNumericFilterClick,
  onAddRelatedEntityFilterClick,
  onAddUniquenessFilterClick,
}: {
  type: SimpleEventTypeLegacy | undefined;
  uniquenessFilters: any;
  onAddConceptFilterClick: () => void;
  onAddNumericFilterClick: () => void;
  onAddRelatedEntityFilterClick: () => void;
  onAddUniquenessFilterClick: () => void;
}): CohortBuilderEditModalActionButtonProps[] => {
  const intl = useIntl();
  const availableTypes = getAvailableEventTypes(type);

  const actions: CohortBuilderEditModalActionButtonProps[] = [];

  if (availableTypes.includes(FilterTypeLegacy.CONCEPT)) {
    actions.push({
      id: 'add-concept-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.conceptFilter',
      }),
      onClick: onAddConceptFilterClick,
      disabled: !type,
    });
  }

  if (availableTypes.includes(FilterTypeLegacy.NUMERIC)) {
    actions.push({
      id: 'add-numeric-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.numericFilter',
      }),
      onClick: onAddNumericFilterClick,
      disabled: !type,
    });
  }

  if (availableTypes.includes(FilterTypeLegacy.RELATED_ENTITY)) {
    actions.push({
      id: 'add-related-entity-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.relatedEntityFilter',
      }),
      onClick: onAddRelatedEntityFilterClick,
      disabled: !type,
    });
  }

  if (availableTypes.includes(FilterTypeLegacy.UNIQUENESS)) {
    actions.push({
      id: 'add-uniqueness-filter',
      displayLabel: intl.formatMessage({
        id: 'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.uniquenessFilter',
      }),
      title: uniquenessFilters.length
        ? intl.formatMessage({
            id: 'projects.cohortBuilderPage.simpleEventsEditModal.uniquenessFilterRestrictionTitle',
          })
        : undefined,
      onClick: onAddUniquenessFilterClick,
      disabled: !type,
    });
  }

  return actions;
};
